var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentView,{tag:"div",staticClass:"informationPriceView",attrs:{"extr":_vm.extrData}})
}
var staticRenderFns = []

export { render, staticRenderFns }